import type { BlobType } from "@pdfking/blob"

export const BlobNative = async (blob: BlobType): Promise<Blob> => {
  if (blob instanceof Blob) return blob
  return new Blob([await blob.arrayBuffer()], { type: blob.type })
}
